import keyMirror from "keymirror";

export default keyMirror({
    NOT_RATED: null,
    POSITIVE_2: null,
    NEGATIVE_2: null,
    POSITIVE_3: null,
    NEUTRAL_3: null,
    NEGATIVE_3: null,
    POSITIVE_4: null,
    NEUTRAL_POSITIVE_4: null,
    NEUTRAL_NEGATIVE_4: null,
    NEGATIVE_4: null,
    POSITIVE_5: null,
    NEUTRAL_POSITIVE_5: null,
    NEUTRAL_5: null,
    NEUTRAL_NEGATIVE_5: null,
    NEGATIVE_5: null,
    STARS_1: null,
    STARS_2: null,
    STARS_3: null,
    STARS_4: null,
    STARS_5: null,
});
